"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotBonusUtils = void 0;
const react_1 = require("react");
const api_1 = require("./api");
const interface_1 = require("../interface/interface");
const trade_utils_lib_1 = require("trade_utils_lib");
var BotBonusUtils;
(function (BotBonusUtils) {
    BotBonusUtils.useBotBonus = (isActive) => {
        const [botBonusInfo, setBotBonusInfo] = (0, react_1.useState)({ loading: isActive === true });
        (0, react_1.useEffect)(() => {
            if (!isActive) {
                return;
            }
            const sub = api_1.BotBonusApi.requestUserBotBonus().subscribe({
                next: (data) => {
                    setBotBonusInfo({ data: data, loading: false });
                },
                error: (err) => {
                    setBotBonusInfo({ error: err, loading: false });
                },
            });
            return () => {
                sub.unsubscribe();
            };
        }, [isActive]);
        return botBonusInfo;
    };
    BotBonusUtils.collect = (bonusId) => {
        return api_1.BotBonusApi.collectBotBonus(bonusId);
    };
    BotBonusUtils.requestBotBonus = (bonusId) => {
        return api_1.BotBonusApi.requestBotBonus(bonusId);
    };
    /** 获取发财金使用记录 */
    BotBonusUtils.useBotBonusRecord = () => {
        const [data, setData] = (0, react_1.useState)();
        const [loading, setLoading] = (0, react_1.useState)(true);
        const [errorMsg, setErrorMsg] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            setLoading(true);
            api_1.BotBonusApi.requestBotBonusRecord().subscribe({
                next(value) {
                    setLoading(false);
                    setData(Array.isArray(value.results) ? value.results : []);
                    setErrorMsg(undefined);
                },
                error(err) {
                    setErrorMsg(err);
                    setLoading(false);
                },
                complete() {
                    setLoading(false);
                },
            });
        }, []);
        return { data, loading, errorMsg };
    };
    /** 发财金活动状态检查 */
    BotBonusUtils.useBotBonusTaskState = ({ bonus_id }) => {
        const [loading, setLoading] = (0, react_1.useState)(true);
        const [errorMsg, setErrorMsg] = (0, react_1.useState)();
        const [data, setData] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            setLoading(true);
            api_1.BotBonusApi.checkBonusTaskState(bonus_id).subscribe({
                next(value) {
                    setLoading(false);
                    setErrorMsg(undefined);
                    setData(value);
                },
                error(err) {
                    setLoading(false);
                    setErrorMsg(err);
                },
                complete() {
                    setLoading(false);
                },
            });
        }, []);
        return { loading, errorMsg, data };
    };
    /** 发财金活动报名 */
    BotBonusUtils.bonusTaskRegister = (task_id) => {
        return api_1.BotBonusApi.bonusTaskRegister(task_id);
    };
    /** 发财金活动领取 */
    BotBonusUtils.bonusTaskClaim = (bonus_id) => {
        return api_1.BotBonusApi.bonusTaskClaim(bonus_id);
    };
    /** 发财金活动领取预检查 */
    BotBonusUtils.bonusTaskClaimCheck = (bonus_id) => {
        return api_1.BotBonusApi.checkBonusTaskState(bonus_id);
    };
    // 适用于领取和注册弹窗的各种按钮枚举
    // 各按钮会根据领取和注册返回的状态 展示不同
    let EButtonType;
    (function (EButtonType) {
        EButtonType[EButtonType["cancel"] = 0] = "cancel";
        EButtonType[EButtonType["support"] = 1] = "support";
        EButtonType[EButtonType["register"] = 2] = "register";
        EButtonType[EButtonType["claim"] = 3] = "claim";
        EButtonType[EButtonType["gotIt"] = 4] = "gotIt";
        EButtonType[EButtonType["bonusDetail"] = 5] = "bonusDetail";
    })(EButtonType = BotBonusUtils.EButtonType || (BotBonusUtils.EButtonType = {}));
    // 入金条件翻译转换
    BotBonusUtils.getBonusTaskConditionTypeI18n = ($st, type) => {
        switch (type) {
            // 首次入金
            case interface_1.BonusConditionType.deposit_first:
                return $st("bonus_task_register_deposit_first");
            // 累计入金
            case interface_1.BonusConditionType.deposit_cumulative:
                return $st("bonus_task_register_deposit_cumulative");
            default:
                return "";
        }
    };
    // 获取注册成功后 弹窗文案
    BotBonusUtils.getBonusRegisterSuccessTipsConfig = ({ data, $st, dateFormatter, }) => {
        const obj = {
            textDesc: "",
            title: $st("bonus_task_register_success_title"),
            tips: "",
            btnType: [EButtonType.gotIt],
        };
        // 允许领取时，展示取消/去领取按钮
        if (data.sendable) {
            obj.btnType = [EButtonType.cancel, EButtonType.claim];
        }
        /** 非首次报名 */
        if (data.task_registered && !data.first_registered_success && !data.sendable) {
            obj.title = $st("bonus_task_dup_register_title");
            /** 入金条件未达成 */
            if (data.condition && [interface_1.BonusConditionType.deposit_cumulative, interface_1.BonusConditionType.deposit_first].includes(data.condition.type)) {
                obj.textDesc = $st("bonus_task_dup_register_deposit_not_ready", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    bonusAmount: data.bonus.bonus_amount,
                    start: dateFormatter.year_second(Number(data.task.start_time)),
                    end: dateFormatter.year_second(Number(data.task.end_time)),
                    type: BotBonusUtils.getBonusTaskConditionTypeI18n($st, data.condition.type),
                    amount: data.condition.deposit_amount,
                });
            }
            else {
                /** 未知条件未达成 */
                obj.textDesc = $st("bonus_task_dup_register_default_tip", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    bonusAmount: data.bonus.bonus_amount,
                    start: dateFormatter.year_second(Number(data.task.start_time)),
                });
            }
            return obj;
        }
        /** 报名成功 但是不符合入金条件 */
        if (!data.sendable &&
            data.condition &&
            [interface_1.BonusConditionType.deposit_cumulative, interface_1.BonusConditionType.deposit_first].includes(data.condition.type)) {
            obj.textDesc = $st("bonus_task_register_success_deposit_not_ready", {
                bonusDesc: data.bonus.bonus_copywriting,
                bonusAmount: data.bonus.bonus_amount,
                end: dateFormatter.year_second(Number(data.task.end_time)),
                type: BotBonusUtils.getBonusTaskConditionTypeI18n($st, data.condition.type),
                amount: data.condition.deposit_amount,
            });
            return obj;
        }
        /** 报名成功 条件是入金 入金条件已经满足 可直接领取 */
        if (data.sendable &&
            data.condition &&
            [interface_1.BonusConditionType.deposit_cumulative, interface_1.BonusConditionType.deposit_first].includes(data.condition.type)) {
            obj.textDesc = $st("bonus_task_register_success_deposit_ready", {
                bonusDesc: data.bonus.bonus_copywriting,
                bonusAmount: data.bonus.bonus_amount,
                type: BotBonusUtils.getBonusTaskConditionTypeI18n($st, data.condition.type),
                amount: data.condition.deposit_amount,
            });
            obj.title = $st("bonus_task_register_success_title_claim");
            obj.tips = $st("bonus_task_register_success_tips", {
                end: dateFormatter.year_second(Number(data.task.end_time)),
            });
            return obj;
        }
        /** 报名成功 条件未知 但条件已经满足 可直接领取 */
        if (data.sendable && data.condition) {
            obj.textDesc = $st("bonus_task_register_success_claim_ready", {
                bonusDesc: data.bonus.bonus_copywriting,
                bonusAmount: data.bonus.bonus_amount,
            });
            obj.title = $st("bonus_task_register_success_title_claim");
            obj.tips = $st("bonus_task_register_success_tips", {
                end: dateFormatter.year_second(Number(data.task.end_time)),
            });
            return obj;
        }
        /** 报名成功 无条件 可直接领取 */
        if (data.sendable) {
            obj.textDesc = $st("bonus_task_register_success_claim_ready", {
                bonusDesc: data.bonus.bonus_copywriting,
                bonusAmount: data.bonus.bonus_amount,
            });
            obj.tips = $st("bonus_task_register_success_tips", {
                end: dateFormatter.year_second(Number(data.task.end_time)),
            });
        }
        else {
            /** 报名成功 条件不满足 条件未知 不可直接领取 */
            obj.textDesc = $st("bonus_task_register_success_condition_not_ready", {
                bonusDesc: data.bonus.bonus_copywriting,
                bonusAmount: data.bonus.bonus_amount,
            });
        }
        return obj;
    };
    // 获取注册失败后 弹窗文案
    BotBonusUtils.getBonusRegisterFailedTipsConfig = ({ data, $st, dateFormatter, }) => {
        // 数据异常
        const errorData = !data || !data.bonus || !data.task;
        if (errorData) {
            return {
                textDesc: $st("bonus_task_register_failed_error_content"),
                title: $st("bonus_task_register_failed_error"),
                btnType: [EButtonType.cancel, EButtonType.support],
            };
        }
        const obj = {
            textDesc: $st("bonus_task_register_failed_default", {
                bonusDesc: data.bonus.bonus_copywriting,
            }),
            title: $st("bonus_task_register_failed_title"),
            btnType: [EButtonType.gotIt],
        };
        // 时间检验无效
        if (data.failed_reason === interface_1.BonusRegisterFailedReason.task_time_invalid) {
            const n = Date.now();
            // 未开始
            if (new trade_utils_lib_1.SafeDecimal(n).lessThan(data.task.start_time)) {
                obj.textDesc = $st("bonus_task_register_failed_not_start", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    start: dateFormatter.year_second(Number(data.task.start_time)),
                });
                obj.title = $st("bonus_task_register_failed_title_start");
                return obj;
            }
            // 已结束
            if (new trade_utils_lib_1.SafeDecimal(n).greaterThan(data.task.end_time)) {
                obj.textDesc = $st("bonus_task_register_failed_after_end", {
                    bonusDesc: data.bonus.bonus_copywriting,
                    end: dateFormatter.year_second(Number(data.task.end_time)),
                });
                obj.title = $st("bonus_task_register_failed_title_end");
                return obj;
            }
            return obj;
        }
        // 仅限邀请用户
        if (data.failed_reason === interface_1.BonusRegisterFailedReason.only_invited) {
            obj.textDesc = $st("bonus_task_register_failed_only_invited", {
                bonusDesc: data.bonus.bonus_copywriting,
            });
            return obj;
        }
        // 仅限新用户
        if (data.failed_reason === interface_1.BonusRegisterFailedReason.only_newly_user) {
            obj.textDesc = $st("bonus_task_register_failed_only_newly_user", {
                bonusDesc: data.bonus.bonus_copywriting,
            });
            return obj;
        }
        // 仅限未交易过合约的用户
        if (data.failed_reason === interface_1.BonusRegisterFailedReason.only_no_future_traded) {
            obj.textDesc = $st("bonus_task_register_failed_only_future_traded", {
                bonusDesc: data.bonus.bonus_copywriting,
            });
            return obj;
        }
        return obj;
    };
    // 获取领取失败后 弹窗文案
    BotBonusUtils.getBonusClaimFailedTipsConfig = ({ data, $st, dateFormatter, setNeedKycView, }) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const obj = {
            title: $st("bonus_claim_error_bonus_default"),
            textDesc: $st("bonus_claim_error_bonus_default_content"),
            btnType: [EButtonType.cancel, EButtonType.support],
        };
        // 服务端没有返回 bonus信息或者task信息，
        // 一般情况下是id无效造成的
        if (!data.bonus || !data.task) {
            return obj;
        }
        // 不在活动时间范围内
        if (new trade_utils_lib_1.SafeDecimal(Date.now()).lessThan(data.task.start_time)) {
            obj.title = $st("bonus_task_register_failed_title_start");
            obj.textDesc = $st("bonus_claim_error_not_start", {
                bonusDesc: data.bonus.bonus_copywriting,
                start: dateFormatter.year_second(Number(data.task.start_time)),
            });
            obj.btnType = [EButtonType.gotIt];
            return obj;
        }
        if (new trade_utils_lib_1.SafeDecimal(Date.now()).greaterThan(data.task.end_time)) {
            obj.title = $st("bonus_task_register_failed_title_end");
            obj.textDesc = $st("bonus_claim_error_after_end", {
                bonusDesc: data.bonus.bonus_copywriting,
                end: dateFormatter.year_second(Number(data.task.end_time)),
            });
            obj.btnType = [EButtonType.gotIt];
            return obj;
        }
        // 报名成功 不满足入金条件 不能领取
        if (data.task_registered &&
            !data.sendable &&
            ((_a = data.failed_info) === null || _a === void 0 ? void 0 : _a.failed_reason) &&
            [interface_1.BotBonusFailReason.duplicate_collect].includes(data.failed_info.failed_reason)) {
            obj.title = $st("bonus_claim_error_duplicate");
            obj.textDesc = $st("bonus_claim_error_duplicate_content", {
                bonusDesc: data.bonus.bonus_copywriting,
                bonusAmount: data.bonus.bonus_amount,
            });
            obj.btnType = [EButtonType.cancel, EButtonType.bonusDetail];
            return obj;
        }
        // 未报名
        if (!data.task_registered) {
            obj.title = $st("bonus_claim_error_not_register");
            obj.textDesc = $st("bonus_claim_error_not_register_content", { bonusDesc: data.bonus.bonus_copywriting });
            obj.btnType = [EButtonType.cancel, EButtonType.register];
            return obj;
        }
        // 报名成功 不满足入金条件 不能领取
        if (data.task_registered &&
            !data.sendable &&
            ((_b = data.failed_info) === null || _b === void 0 ? void 0 : _b.failed_reason) &&
            [interface_1.BotBonusFailReason.first_deposit_not_enough, interface_1.BotBonusFailReason.cumulative_deposit_not_enough].includes(data.failed_info.failed_reason)) {
            const typeTransfer = {
                [interface_1.BotBonusFailReason.first_deposit_not_enough]: interface_1.BonusConditionType.deposit_first,
                [interface_1.BotBonusFailReason.cumulative_deposit_not_enough]: interface_1.BonusConditionType.deposit_cumulative,
            }[data.failed_info.failed_reason];
            obj.title = $st("bonus_claim_error_condition_not_ready");
            obj.textDesc = $st("bonus_claim_error_deposit_not_ready_content", {
                bonusDesc: data.bonus.bonus_copywriting,
                bonusAmount: data.bonus.bonus_amount,
                end: dateFormatter.year_second(Number(data.task.end_time)),
                type: BotBonusUtils.getBonusTaskConditionTypeI18n($st, typeTransfer),
                amount: ((_c = data.failed_info) === null || _c === void 0 ? void 0 : _c.deposit_amount) || "",
            });
            obj.btnType = [EButtonType.gotIt];
            return obj;
        }
        // 报名成功 不满足kyc条件 不能领取
        if (data.task_registered &&
            !data.sendable &&
            ((_d = data.failed_info) === null || _d === void 0 ? void 0 : _d.failed_reason) &&
            [interface_1.BotBonusFailReason.need_kyc].includes(data.failed_info.failed_reason)) {
            setNeedKycView(true);
            return obj;
        }
        // 存在未使用的发财金
        if (data.task_registered &&
            !data.sendable &&
            ((_e = data.failed_info) === null || _e === void 0 ? void 0 : _e.failed_reason) &&
            ((_f = data.failed_info) === null || _f === void 0 ? void 0 : _f.failed_reason) === interface_1.BotBonusFailReason.exist_not_used_bonus) {
            obj.title = $st("bonus_claim_error_bonus_un_use");
            obj.textDesc = $st("bonus_claim_error_bonus_un_use_content");
            obj.btnType = [EButtonType.cancel, EButtonType.bonusDetail];
            return obj;
        }
        // 存在未领取的发财金
        if (data.task_registered &&
            !data.sendable &&
            ((_g = data.failed_info) === null || _g === void 0 ? void 0 : _g.failed_reason) &&
            ((_h = data.failed_info) === null || _h === void 0 ? void 0 : _h.failed_reason) === interface_1.BotBonusFailReason.exist_not_collect_bonus) {
            obj.title = $st("bonus_claim_error_bonus_un_use");
            obj.textDesc = $st("bonus_claim_error_bonus_un_collect_content");
            obj.btnType = [EButtonType.gotIt];
            return obj;
        }
        // 发财金 超出预算 过期 不存在的情况
        if (data.task_registered &&
            !data.sendable &&
            (!data.bonus ||
                !data.task ||
                (((_j = data.failed_info) === null || _j === void 0 ? void 0 : _j.failed_reason) &&
                    [interface_1.BotBonusFailReason.bonus_expire, interface_1.BotBonusFailReason.bonus_not_exist, interface_1.BotBonusFailReason.exceed_budget].includes((_k = data.failed_info) === null || _k === void 0 ? void 0 : _k.failed_reason)))) {
            return obj;
        }
        // 报名成功 不满足领取条件 条件未知 不能领取
        if (data.task_registered && !data.sendable && ((_l = data.failed_info) === null || _l === void 0 ? void 0 : _l.failed_reason)) {
            obj.title = $st("bonus_claim_error_condition_not_ready");
            obj.textDesc = $st("bonus_claim_error_condition_not_ready_content", {
                bonusDesc: data.bonus.bonus_copywriting,
                bonusAmount: data.bonus.bonus_amount,
                end: dateFormatter.year_second(Number(data.task.end_time)),
            });
            obj.btnType = [EButtonType.gotIt];
            return obj;
        }
        return obj;
    };
})(BotBonusUtils || (exports.BotBonusUtils = BotBonusUtils = {}));
